// Ported from files/snapdraw-design-kit/code/src/components/ui/sonner.tsx
// (thin wrapper over the `sonner` npm package). Used for the "{name}
// updated" confirmation on a real client's edit save (backlog J16,
// ClientFormPage.tsx) — the kit's __root.tsx mounts this once and uses it
// across several routes; this app only fires it from the client edit save
// path today. Uses this app's own Tailwind tokens (bg-background,
// text-foreground, border-border, bg-primary), so no adaptation from the
// kit was needed.
import { Toaster as Sonner } from "sonner";

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
  return (
    <Sonner
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg",
          description: "group-[.toast]:text-muted-foreground",
          actionButton: "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton: "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
        },
      }}
      {...props}
    />
  );
};

export { Toaster };
